<template>
    <g>
        <menu_finger v-if="this.$store.state.study == 'finger'" />
        <menu_reco v-else-if="this.$store.state.study == 'reco'" />
        <home_choke v-else-if="this.$store.state.study == 'choke'" />
        <home_licr35 v-else-if="this.$store.state.study == 'licr35'" />
        <home_ordloopen v-else-if="this.$store.state.study == 'ordloopen'" />
        <menu_itest
            v-else-if="this.$store.state.study == 'ipark' && this.$store.state.condition == 'itest'"
        />
        <study_closed
            v-else-if="closed_studies.indexOf(this.$store.state.study) != -1"
        />
        <taskMenu v-else />
    </g>
</template>

<script>
// menu:
import taskMenu from "@/v/taskMenu/_.vue";
import menu_finger from "@/v/finger/menu/menu_finger.vue";
import menu_reco from "@/v/reco/menu/menu_reco.vue";
import home_choke from "@/v/choke/home/_.vue";
import home_licr35 from "@/v/licr35/home/_.vue";
import home_ordloopen from "@/v/ordloopen/home/_.vue";
import study_closed from "@/v/home/study_closed.vue";
// iTEST: ipark's tests for a psychologist's patients, still in use (accounts itest_*).
import menu_itest from "@/v/taskMenu/menu_itest.vue";
// Concluded studies (participants get study_closed instead):
//import menu_ipark from "@/v/taskMenu/menu_ipark.vue";
//import menu_mind_ad from "@/v/mind_ad/menu/menu_mind_ad.vue";
//import menu_anx from "@/v/anx/menu/menu_anx.vue";
//import menu_nfl from "@/v/nfl/menu/menu_nfl.vue";
//import menu_nfl2 from "@/v/nfl2/menu/menu_nfl2.vue";
import persist from "@/persist.js";
import lang from "@/lang.js";

export default {
    name: "home",
    components: {
        taskMenu,
        menu_finger,
        menu_reco,
        home_choke,
        home_licr35,
        home_ordloopen,
        menu_itest,
        study_closed,
    },
    data: () => {
        return {
            closed_studies: ["ipark", "mind_ad", "anx", "nfl", "nfl2"],
        };
    },
    mounted() {
        const language = persist.get_locally_saved("lang");
        if (language != null && language != "") {
            //console.log('lang = ' + language);
            this.$shared.text = lang.getLocalisedText(language);
            //console.log(this.$shared.text);
        }
    },
};
</script>
